import React from 'react';
import { Box } from '@chakra-ui/react';
import CareersFooter from '../components/CareersComponents/CareersFooter';
import JoinUsHero from '../components/CareersComponents/JoinUsComponents/JoinUsHero';
import JoinUsStatsGrid from '../components/CareersComponents/JoinUsComponents/JoinUsStatsGrid';
import JoinUsAboutSection from '../components/CareersComponents/JoinUsComponents/JoinUsAboutSection';
import JoinUsTeamActivity from '../components/CareersComponents/JoinUsComponents/JoinUsTeamActivity';

const JoinUs = () => {
  return (
    <>
      <Box bg="#25575F" minH="80vh" pb={24} position="relative">
        <JoinUsHero />
        <Box position="relative" zIndex={2} mt={{ base: -20, md: -24 }}>
          <JoinUsStatsGrid />
        </Box>
      </Box>
      <JoinUsAboutSection />
      <JoinUsTeamActivity />
      <CareersFooter />
    </>
  );
};

export default JoinUs;
